export const EMPLOYEE_CONTRACT_TYPES = {
  EC: 'Employment contract',
  B2B: 'B2B contract',
  CFS: 'Contract for services',
  INTERNSHIP: 'Internship',
};

export const EMPLOYEE_CONTRACT_TYPES_ALIASES = Object.fromEntries(
  Object.entries(EMPLOYEE_CONTRACT_TYPES).map(([key]) => [key, key.toString()]),
);
